<div class="help-contents-wrap">

  <a class="help-close-btn" (click)="onClose($event)"></a>

  <div class="help-head-box">

    <div class="head-txt-box">도움말</div>

    <!-- div class="help-img-box">
      <img src="assets/img/img_help_contents.svg" alt="이미지">
    </div -->
  </div>



  <div class="help-body-box">

    <div class="help-item-box">
      <div class="item-subject-box">음성 고저장단 표시선</div>
      <div class="item-con-box">'나의 말 소리'를 눈으로 보게 하는 표시선으로 자신의 고저장단과 비교해 봅시다.<br>
        선의 모양이 유사하면 성공!</div>
    </div>

  </div>

  <div class="help-foot-box">

    <div class="foot-msg-box">마이크가 정상으로 작동을 하지 않을 때</div>

    <div class="foot-menu-box">
      <a class="foot-menu-btn type-0"
         [routerLink]="['/board', BBS_CATEGORY.USAGE, RECORDER_HELP_BBS_ID]">마이크 설정 도움</a>
    </div>

  </div>

</div>
